export default __webpack_public_path__ + "images/TG.0766834.png";